<script setup lang="ts">
// Decorative background art for the FlashStudies (school) auth screens, the
// counterpart to UserAuthPageDecoration on the SET App (parent/child) side.
//
// Positioned `fixed`, not `absolute`, for two reasons: the shapes stay pinned to
// the viewport corners while a long form (register) scrolls past them, and they
// stop contributing to the scroll container's height — as absolutes anchored to
// `bottom` they stretched the page and pushed the star below the fold.
//
// Purely ornamental: `aria-hidden` keeps it out of the reading order and
// `pointer-events: none` keeps it from swallowing clicks meant for the form.
// Desktop-only because the shapes crowd the form at phone widths.
</script>

<template>
  <div
    aria-hidden="true"
    class="flash-decor"
  >
    <q-img
      src="/img/register-yellow-desktop.webp"
      no-spinner
      class="fixed desktop-only flash-decor-mark"
      style="width: 11vw; top: 6dvh; left: 3vw"
    />
    <q-img
      src="/img/flashStartLeft.png"
      no-spinner
      class="fixed desktop-only"
      style="width: 18vw; bottom: 0; left: 0"
    />
    <q-img
      src="/img/starFlashRight.png"
      no-spinner
      class="fixed desktop-only"
      style="width: 15vw; bottom: 8dvh; right: 0"
    />
  </div>
</template>

<style scoped>
.flash-decor {
  pointer-events: none;
  z-index: 0;
}

.flash-decor-mark {
  transform: rotate(-12deg);
}
</style>
